import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
import { Router } from '@angular/router';
import { ProcessFlowService,forwardConfig } from "@shared/components/process-flow/process-flow.service";

@Injectable({
  providedIn: 'root'
})
export class JyMessageService extends BaseService {
  url = 'api/user';
  personUrl = "api/person";
  constructor(http: HttpClient,private router:Router,private processFlowService:ProcessFlowService) {
    super(http);
  }
  getUrl(): string {
    return this.url;
  }
  //获取当前登录用户基本信息
  getUserInfo(): Observable<any> {
    const url = `${this.getUrl() + "/current"}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`query object`)),
      catchError(this.handleError<any>(`geted currentUser fail`)),
    );
  }
  //获取当前登录用户岗位信息
  getUserPosition():Observable<any> {
    const url = `${this.personUrl}/current`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getLoginPerson`)),
      catchError(this.handleError<any>(`getLoginPerson`))
    );
  }

//  获取前十条未读的通告
  getNoticeData():Observable<any> {
    const url = `api/info-status?page=0&size=10&dataAssignsJson=%5B%5D&sort=createdDate,DESC&propertyNames=readStatus&propertyValues=0`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getLoginPerson`)),
      catchError(this.handleError<any>(`getLoginPerson`))
    );
  }

//  系统通知点击查看时执行的方法
  readMessage(notice){
    if(notice.information.type == 1){
      window.open(notice.information.url);
      return;
    }
    if(notice.information.type == 2){
      this.router.navigateByUrl(notice.information.url);
      return;
    }
    if(notice.information.type == 3){
      let process = JSON.parse(notice.information.url);
      let processConfig = new forwardConfig();
      processConfig.visible = true;
      Object.assign(processConfig,process);
      this.processFlowService.openForward(processConfig);
      return;
    }
  }
}
